
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    name: { type: String, required: true },
    imgUrl: { type: String, required: true }
  }
})
